module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_02_6NX26_1SF_GLR.9195924d.png";